import { getSpaceSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy community URL. A feed sub-space redirects to `/{program}/{feedSlug}`;
 * a container (multi-feed) redirects to the program home.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/community')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getSpaceSlugPathQueryOptions(params.id));
    // A feed sub-space resolves to program+feed; a container has no feed slug.
    if (path.moduleSlug) {
      throw redirect({
        to: '/community-hub/$programSlug/$feedSlug',
        params: { programSlug: path.programSlug, feedSlug: path.moduleSlug },
        replace: true,
      });
    }
    throw redirect({ to: '/programs/$programSlug', params: { programSlug: path.programSlug }, replace: true });
  },
});
